import { render } from "./HomeOld.vue?vue&type=template&id=b01335aa"
import script from "./HomeOld.vue?vue&type=script&lang=js"
export * from "./HomeOld.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__